import { render, staticRenderFns } from "./changeType.vue?vue&type=template&id=354b859e&scoped=true"
import script from "./changeType.vue?vue&type=script&lang=js"
export * from "./changeType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354b859e",
  null
  
)

export default component.exports